/** Format a minute-of-day offset as HH:MM. 1440 is 24:00. */
export function formatMinuteOfDay(total) {
  const minutes = Number(total);
  if (!Number.isFinite(minutes)) return '';
  const clamped = Math.max(0, Math.min(24 * 60, Math.round(minutes)));
  const hours = Math.floor(clamped / 60);
  const mins = clamped % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

/** "10:30–14:00" for one planned outage slot. */
export function formatOutageRange(start, end) {
  return `${formatMinuteOfDay(start)}–${formatMinuteOfDay(end)}`;
}

export function formatOutageRanges(slots) {
  if (!Array.isArray(slots) || slots.length === 0) return '';
  return slots.map(slot => formatOutageRange(slot.start, slot.end)).join(', ');
}

/** One selectable group per collapsed queue, ordered 1.1, 1.2, 2.1, … */
export function outageGroupChoices(queues) {
  if (!Array.isArray(queues)) return [];
  const choices = [];
  queues.forEach(queue => {
    String(queue?.groups || '')
      .split(',')
      .map(part => part.trim())
      .filter(Boolean)
      .forEach(group => {
        choices.push({ group, today: queue.today, tomorrow: queue.tomorrow });
      });
  });
  return choices.sort((left, right) => {
    const leftKey = groupSortKey(left.group);
    const rightKey = groupSortKey(right.group);
    return leftKey[0] - rightKey[0] || leftKey[1] - rightKey[1] || leftKey[2].localeCompare(rightKey[2]);
  });
}

function groupSortKey(label) {
  const match = String(label).match(/(\d+)(?:\.(\d+))?/);
  if (!match) return [Number.MAX_SAFE_INTEGER, 0, label];
  return [Number(match[1]), Number(match[2] || 0), label];
}

export function hasOutageCoordinates(latitude, longitude) {
  if (latitude == null || longitude == null || latitude === '' || longitude === '') {
    return false;
  }
  const lat = Number(latitude);
  const lng = Number(longitude);
  return Number.isFinite(lat) && Number.isFinite(lng);
}
